import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import * as authActions from '../../actions/authAction';

class AuthNav extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.onLogout = this.onLogout.bind(this);
    }

    onLogout() {
        this.props.actions.logout();
    }

    render() {
        let isLogged = this.props.me && !this.props.me.error;
        return (
            <div>
                {isLogged && <Link to="/me">{this.props.me.name}</Link>}
                &nbsp;{isLogged && <button className="btn btn-danger btn-xs" onClick={this.onLogout}>Logout</button>}
                {!isLogged && <Link to="/login" className="pull-right" activeClassName="active">Login</Link>}
            </div>
        );
    }
}

AuthNav.propTypes = {
    me: PropTypes.object,
    actions: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        me: state.me
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(authActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AuthNav);


/** WEBPACK FOOTER **
 ** ./src/components/auth/AuthNav.js
 **/